import { TDeviceType } from '@cian/ui-kit/types';

export const getSiteType = (deviceType: TDeviceType) => {
  return deviceType === 'phone' ? 'mobile' : deviceType;
};
